const connexion = [
  {
    path: "/",
    name: "connexion",
    component: () => import("@/views/Signin"),
  },
];

const admin = [
  {
    path: "/admin",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "dashboard",
    component: () => import("@/views/Dashboard"),
  },
  {
    path: "/mon-tableau",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "dashboardOnly",
    component: () => import("@/views/DashboardOnly"),
  },
  {
    path: "/permission",
    //meta: { requiresPermission: 'PRIVILEGE_UTILISATEUR_PERMISSION' },
    name: "permissionCreer",
    component: () => import("@/views/userGestion/Permission.vue")
  },
  {
    path: "/role",
    //meta: { requiresPermission: 'PRIVILEGE_UTILISATEUR_ROLE' },
    name: "roleCreer",
    component: () => import("@/views/userGestion/role.vue")
  },
  {
    path: "/categorie",
    // meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "categorie",
    component: () => import("@/views/referentiel/categorie.vue")
  },
  {
    path: "/commission",
    // meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "commission",
    component: () => import("@/views/referentiel/commission.vue")
  },
  {
    path: "/sousCategorie",
    // meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "sousCategorie",
    component: () => import("@/views/referentiel/sousCategorie.vue")
  },
  {
    path: "/typeFichier",
    // meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "typeFichier",
    component: () => import("@/views/referentiel/fileType.vue")
  },
  {
    path: "/utilisateur",
    //meta: { requiresPermission: 'PRIVILEGE_UTILISATEUR_UTILISATEUR' },
    name: "utilisateur",
    component: () => import("@/views/userGestion/utilisateur.vue")
  },
  {
    path: "/profil",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "profil",
    component: () => import("@/views/userGestion/profilUser.vue")
  },
  {
    path: "/demandes",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "demandes",
    component: () => import("@/views/demandes/demande.vue")
  },
  {
    path: "/actualites",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "actualites",
    component: () => import("@/views/referentiel/actualite.vue")
  },
  {
    path: "/societe",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "societe",
    component: () => import("@/views/societes/societe.vue")
  },
  {
    path: "/fonction",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "fonction",
    component: () => import("@/views/societes/fonction.vue")
  },
  {
    path: "/mesSociete",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "mesSociete",
    component: () => import("@/views/societes/mesSociete.vue")
  },
  {
    path: "/addSociete",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "addSociete",
    component: () => import("@/views/societes/addSociete.vue")
  },
  {
    path: "/demandesSociete",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "demandesSociete",
    component: () => import("@/views/demandes/demandeSociete.vue")
  },
  {
    path: "/maintientPP",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "maintientPP",
    component: () => import("@/views/demandes/physiqueMaintient.vue")
  },
  {
    path: "/maintientPM",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "maintientPM",
    component: () => import("@/views/demandes/societeMaintien.vue")
  },
  {
    path: "/message",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "message",
    component: () => import("@/views/mails/message.vue")
  },
  {
    path: "/newsletters",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "newsletters",
    component: () => import("@/views/mails/newsletters.vue")
  },
  {
    path: "/fiche",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "fiche",
    component: () => import("@/views/expertComptable/ficheAdhesion.vue")
  },
  {
    path: "/renouvellement",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "renouvellement",
    component: () => import("@/views/expertComptable/renouvellement.vue")
  },
  {
    path: "/dirigeants",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "dirigeants",
    component: () => import("@/views/societes/dirigeant.vue")
  },
  {
    path: "/mesRenouvellements",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "mesRenouvellements",
    component: () => import("@/views/expertComptable/newRenouvellement.vue")
  },
  {
    path: "/mesCotisations",
    //meta: { requiresPermission: ['ROLE_ADMIN'] }, 
    name: "mesCotisations",
    component: () => import("@/views/expertComptable/mesCotisations.vue")
  },
  {
    path: "/cotisationSociete",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "cotisationSociete",
    component: () => import("@/views/expertComptable/cotisationSociete.vue")
  },
  {
    path: "/societeRenouvellement",
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "societeRenouvellement",
    component: () => import("@/views/expertComptable/societeRenouvellement.vue")
  },
  {
    path: "/correction",
    name: "correction",
    component: () => import("@/views/expertComptable/correction.vue"),
    props: true
  },
  {
    path: "/importationPersonne",
    name: "importationPersonne",
    component: () => import("@/views/imports/importPhysique.vue"),
    props: true
  },
  {
    path: "/importationSociete",
    name: "importationSociete",
    component: () => import("@/views/imports/importMorale.vue"),
    props: true
  },
  {
    path: "/signataire",
    name: "signataire",
    component: () => import("@/views/signataire.vue"),
    props: true
  },
  {
    path: "/banque",
    name: "banque",
    component: () => import("@/views/banque.vue"),
    props: true
  },
  {
    path: "/Cotisations",
    name: "Cotisations",
    component: () => import("@/views/Cotisation.vue"),
    props: true
  },
  {
    path: "/formation",
    name: "formation",
    component: () => import("@/views/formation.vue"),
    props: true
  },
  {
    path: "/mes-formations",
    name: "mes-formations",
    component: () => import("@/views/expertComptable/mesFormations.vue"),
    props: true
  },
  {
    path: "/journalisation",
    // meta: { requiresPermission: ['ROLE_ADMIN'] },
    name: "journalisation",
    component: () => import("@/views/fichierLogs.vue")
  },


];

export default [
  {
    path: "/auth",
    component: () => import("@/views/Signin"),
    children: connexion,
  },
  {
    path: "/",
    component: () => import("@/views/espace/Admin"),
    //meta: { requiresPermission: ['ROLE_ADMIN'] },
    children: admin,
  },
  {
    path: "/forget",
    name: "forget",
    component: () => import("@/views/PasswordForget"),
  },
  

];
